'use strict';

/**
 *
 * @name: ModuleCoverCategoryDirective
 *
 */

import DirectiveTemplate from './module-cover-category.directive.html';

function ModuleCoverCategoryDirective(
  $rootScope,
  $state,
  $stateParams,
  $location,
  $compile,
  transObject,
  angularticsService,
  apiCategoryService,
  apiPostService,
  apiSubscriptionsService,
  apiTagService,
  nnModalsService,
  CategoryAnalyticsFactory) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    link: function(scope, element) {

      /**
       *
       * @CONFIG
       *
       */

      var rootWatchers = {};
      var currentPage = 1;

      /**
       *
       * @PUBLIC
       *
       */

      scope.playIndex = function(index) {

        // This is bacause we need to identify the situation when user choses the post for the first time.
        // In this situation postSlug is still empty.
        scope.settings.change = true;

        if (index !== scope.settings.index && $stateParams.postSlug || !$stateParams.postSlug) {

          var data = {
            dontGoNext: true,
          };
          scope.settings.index = index; // triggers _changePlayedPost

          // when the is no postSlug and user choses first post the index won't change
          // (default value for index is 0)

          if (!scope.postChosen && scope.settings.index === index) {

            scope.postChosen = true;
            _changePlayedPost(index);
          }

          scope.postChosen = true;
          $rootScope.$broadcast('filmFinished', data);
        }
      };

      scope.subscribe = function(type) {

        var subscriber = {
          tag: _subscribeTag,
          category: _subscribeCategory
        };

        var unsubscriber = {
          tag: _unsubscribeTag,
          category: _unsubscribeCategory
        };

        var target = (scope.isCategory ? scope.category : scope.tag);

        if ($rootScope.profile && target.isSubscribed === false) {

          subscriber[type]();
        } else if ($rootScope.profile) {

          unsubscriber[type]();
        } else if (!$rootScope.profile) {

          if (scope.isCategory) {

            $rootScope.categoryToFollow = scope.category;
            $rootScope.categoryToBeFollowed = true;
          }

          rootWatchers.profile = $rootScope.$watch('profile', function(newVal) {

            if (newVal) {

              if (scope.isCategory) {

                apiCategoryService
                  .getCategoryBySlug($stateParams.slug)
                  .then(function(result) {

                    if (!result.data.isSubscribed) {

                      subscriber[type]();
                    } else {

                      scope.category.isSubscribed = result.data.isSubscribed;
                    }
                  });
              }

              rootWatchers.profile();
            }
          });

          nnModalsService.showModal('login');
        }
      };

      scope.loadMore = function() {

        var meta = scope.item.metaData;
        currentPage += 1;

        if (isNaN(meta.totalPages) || (!isNaN(meta.totalPages) && currentPage <= meta.totalPages)) {

          apiPostService
            .getPost(
              /* categoryId */
              (scope.isCategory ? scope.category.id : false),
              /* order */
              'publishDate desc',
              /* page */
              currentPage,
              /* limit */
              8,
              /* lovedBy */
              false,
              /* viewedBy */
              false,
              /* isPublished */
              true,
              /* bookmarkedBy */
              false,
              /* contributedBy */
              false,
              /* seriesId */
              false,
              /* playlistId */
              false,
              /* includeImages */
              false,
              /* includeComingSoon */
              false,
              /* isDaily */
              (scope.isTag ? false : true),
              /* sponsorId */
              false,
              /* tagId */
              (scope.isTag ? scope.tag.id : false)
            )
            .then(
              function(result) {

                var catPosts = result.data.items;

                catPosts.forEach(function(post) {

                  _decoratePost(post);
                  scope.posts.push(post);
                });
              }
            );
        }
      };

      /**
       *
       * @PRIVATE
       *
       */

      function _changePlayedPost(newIndex) {

        if (newIndex || newIndex === 0) {

          var extWrap = element.find('.ext-wrap');
          extWrap.stop().animate({
            scrollLeft: 240 * (scope.settings.index - 1)
          }, 300, 'swing');

          if (scope.settings.index !== 0) {

            element.find('.prev').removeClass('hidden');
          } else {

            element.find('.prev').addClass('hidden');
          }

          if (scope.settings.index !== scope.posts.length - 1) {

            element.find('.next').removeClass('hidden');
          } else {

            element.find('.next').addClass('hidden');
          }

          if ($stateParams.postSlug || $location.search().autoplay || scope.postChosen) {

            if (scope.posts[newIndex].statusCn !== 'published' || !scope.posts[newIndex].isPublished) {

              if (newIndex < scope.posts.length - 1) {

                scope.playIndex(newIndex + 1);
              } else {

                scope.playIndex(0);
              }
            }

            if (scope.post && scope.post.id === scope.posts[newIndex].id && scope.posts[newIndex + 1]) {

              apiPostService
                .getPostById(scope.posts[scope.settings.index + 1].id)
                .then(function(res) {

                  _decoratePost(res.data);
                  scope.nextPost = res.data;
                });
            } else if (scope.nextPost && scope.nextPost.id === scope.posts[newIndex].id) {

              scope.post = scope.nextPost;
              _setupAnalyticsData();
              _compilePostDescription();
              scope.postReady = true;
              _changeLocationPath();
              $rootScope.$broadcast('postChange', scope.post);
              _loadNextPost();
            } else {

              apiPostService
                .getPostBySlug(scope.posts[scope.settings.index].translations[$rootScope.lang].slug)
                .then(function(res) {

                  scope.post = res.data;
                  scope.settings.post = res.data;
                  _decoratePost(res.data);
                  _setupAnalyticsData();
                  _compilePostDescription();
                  scope.postReady = true;
                  _changeLocationPath();
                  $rootScope.$broadcast('postChange', scope.post);
                });

              _loadNextPost();
            }
          }
        }
      }

      function _decoratePost(post) {

        transObject.translate(post);
        transObject.setBookmark(post);
        transObject.calendarDate(post);
        transObject.translate(post.category);

        if (post.tags && post.tags.length) {

          post.tags.forEach(function(tag) {

            transObject.translate(tag);
          });
        }

        transObject.myAss(post);

        if (post.contributors && post.contributors.length) {

          post.contributors.forEach(function(contributor) {

            transObject.trueSlug(contributor);
          });
        }
      }

      function _setupAnalyticsData() {

        var source = scope.isCategory ? scope.category : scope.tag;

        var analyticsData = {
          pageID: 'NA',
          primaryCategory: source.translations[$rootScope.lang].slug,
          subCategory1: source.translations[$rootScope.lang].slug,
          subCategory2: source.translations[$rootScope.lang].slug,
          pageType: 'category pages'
        };

        if (scope.post) {

          analyticsData.pageTitle = scope.post.translations[$rootScope.lang].title;
          analyticsData.attributes = {
            videoName: scope.post.translations[$rootScope.lang].title,
            videoID: scope.post.id
          };
        }

        angularticsService.pageTrack(analyticsData);
      }

      function _compilePostDescription() {

        var compileContainer = element.find('.series-post-compile-container');
        compileContainer.empty();
        compileContainer.html('<p data-compile data-ng-if="postReady"></p>');
        $compile(compileContainer.contents())(scope);
      }

      function _loadNextPost() {

        if (scope.posts[scope.settings.index + 1]) {

          apiPostService
            .getPostBySlug(scope.posts[scope.settings.index + 1].translations[$rootScope.lang].slug)
            .then(function(res) {

              _decoratePost(res.data);
              scope.nextPost = res.data;
            });
        } else {

          scope.nextPost = null;
        }
      }

      function _subscribeCategory() {
        console.log('create 111')
        apiSubscriptionsService
          .setSubscription(scope.category.id, 'categoryNotification')
          .then(function() {

            scope.category.isSubscribed = true;
            CategoryAnalyticsFactory.followCategory(scope.category);
          });
      }

      function _subscribeTag() {

        apiTagService
          .subscribe(scope.tag.id)
          .then(function() {

            scope.tag.isSubscribed = true;
          });
      }

      function _unsubscribeCategory() {
        console.log('delete 111')
        apiSubscriptionsService
          .deleteSubscription(scope.category.id, 'categoryNotification')
          .then(function() {

            scope.category.isSubscribed = false;
            CategoryAnalyticsFactory.unfollowCategory(scope.category);
          });
      }

      function _unsubscribeTag() {

        apiTagService
          .unsubscribe(scope.tag.id)
          .then(function() {

            scope.tag.isSubscribed = false;
          });
      }

      function _changeLocationPath() {

        if ($state.params.slug === scope.post.translations[$rootScope.lang].slug) {

          return;
        }

        $rootScope.forceRouterToNotSync = true;
        var path = (scope.isCategory ? '/category/' : '/topic/') + $stateParams.slug + '/' + scope.post.translations[$rootScope.lang].slug;
        $location.path(path);
      }

      function _onModuleLoad() {

        scope.$watch('loaded', function(newVal) {

          if (newVal) {

            scope.item = scope.content();
            scope.posts = scope.item.items;
            scope.category = scope.item.category;
            scope.tag = scope.item.tag;
            scope.isCategory = !!scope.category;
            scope.isTag = !!scope.tag;
            scope.index = scope.item.index;
            scope.post = scope.item.post;
            scope.postChosen = !!scope.post; // this is to recognize when user choses post from slider, as $stateParams.postSlug not change even if URL changes
            scope.nextPost = null;
            scope.postReady = false;

            if (scope.item.post && scope.item.post.translations[$rootScope.lang].content) {

              scope.post = angular.copy(scope.post);
              scope.postReady = true;
            }

            scope.settings = {
              change: !!$stateParams.postSlug,
              index: scope.index,
              post: scope.post || null
            };
          }
        }, true);
      }

      function _onSettingsChange() {

        scope.$watch('settings.change', function(newVal) {

          if (newVal === false || newVal === true) {

            scope.$parent.change = newVal;
          }
        });
      }

      function _onVideoIndexChange() {

        scope.$watch('settings.index', _changePlayedPost);
      }

      function _onDestroy() {

        scope.$on('$destroy', function() {

          Object.keys(rootWatchers)
            .forEach(function(killWatcherKey) {

              rootWatchers[killWatcherKey]();
            });
        });
      }

      /**
       *
       * @INIT
       *
       */

      _onModuleLoad();
      _onSettingsChange();
      _onVideoIndexChange();
      _onDestroy();
    }
  };
}

export default ModuleCoverCategoryDirective;



// WEBPACK FOOTER //
// ./app/pages/category/module-cover-category/module-cover-category.directive.js